<template>
  <div class="next"></div>
</template>

<script>
export default {
  name: "Next",
  props: {
    subnextload: Boolean,
  },
  data() {
    return {
      loadingNum: 0,
      preLoadImg: [
        { src: require('./../page-one/img/datikuang-2-0.png') },
        { src: require('./../page-one/img/datikuang-2-1.png') },
        { src: require('./../page-one/img/datikuang-2-2.png') },
        { src: require('./../page-one/img/datikuang.png') },
        { src: require('./../page-one/img/datikuang2.png') },
        { src: require('./../page-one/img/dot-right.png') },
        { src: require('./../page-one/img/dot-wrong.png') },
        { src: require('./../page-one/img/dot1-r.png') },
        { src: require('./../page-one/img/dot1-w.png') },
        { src: require('./../page-one/img/dot2-r.png') },
        { src: require('./../page-one/img/dot2-w.png') },
        { src: require('./../page-one/img/dot3-r.png') },
        { src: require('./../page-one/img/dot3-w.png') },
        { src: require('./../page-one/img/dot4-r.png') },
        { src: require('./../page-one/img/dot4-w.png') },
        { src: require('./../page-one/img/dot5-r.png') },
        { src: require('./../page-one/img/dot5-w.png') },
        { src: require('./../page-one/img/dot6-r.png') },
        { src: require('./../page-one/img/dot6-w.png') },
        { src: require('./../page-one/img/dot7-r.png') },
        { src: require('./../page-one/img/dot7-w.png') },
        { src: require('./../page-one/img/hbBtn1.png') },
        { src: require('./../page-one/img/hbBtn2.png') },
        { src: require('./../page-one/img/jiqi-1.png') },
        { src: require('./../page-one/img/jiqi-guang.png') },
        { src: require('./../page-one/img/jiqi-txt.png') },
        { src: require('./../page-one/img/jiqi-txt1.png') },
        { src: require('./../page-one/img/jiqi-txt2.png') },
        { src: require('./../page-one/img/jiqi-txt3.png') },
        { src: require('./../page-one/img/jiqi-txt4.png') },
        { src: require('./../page-one/img/jiqi-txt5.png') },
        { src: require('./../page-one/img/jiqi-txt6.png') },
        { src: require('./../page-one/img/jiqi-txt7.png') },
        { src: require('./../page-one/img/jiqi.png') },
        { src: require('./../page-one/img/listHaibaoBg.png') },
        { src: require('./../page-one/img/makehaibaoBtn.png') },
        { src: require('./../page-one/img/p2-1.png') },
        { src: require('./../page-one/img/p2-2.png') },
        { src: require('./../page-one/img/q-blue1.png') },
        { src: require('./../page-one/img/q-green.png') },
        { src: require('./../page-one/img/q-left.png') },
        { src: require('./../page-one/img/q-red.png') },
        { src: require('./../page-one/img/q-right.png') },
        { src: require('./../page-one/img/q1-bg.png') },
        { src: require('./../page-one/img/q1.png') },
        { src: require('./../page-one/img/q2-bg.png') },
        { src: require('./../page-one/img/q2.png') },
        { src: require('./../page-one/img/q3-bg.png') },
        { src: require('./../page-one/img/q3.png') },
        { src: require('./../page-one/img/q4-bg.png') },
        { src: require('./../page-one/img/q4.png') },
        { src: require('./../page-one/img/q5-bg.png') },
        { src: require('./../page-one/img/q5.png') },
        { src: require('./../page-one/img/q6-bg.png') },
        { src: require('./../page-one/img/q6.png') },
        { src: require('./../page-one/img/q7-bg.png') },
        { src: require('./../page-one/img/q7.png') },
        { src: require('./../page-one/img/schaibaoBtn.png') },
        { src: require('./../page-one/img/uploadbg.png') },
        { src: require('./../page-one/img/xingtu-bg.png') },
        { src: require('./../page-one/img/xingtu-loading-0.png') },
        { src: require('./../page-one/img/xingtu-loading-1.png') },
        { src: require('./../page-one/img/xingtu-loading-2.png') },
        { src: require('./../page-one/img/xingtu-loading-3.png') },
        { src: require('./../page-one/img/xingtu-loading-bg.png') },
        { src: require('./../page-one/img/xingtu-q1.png') },
        { src: require('./../page-one/img/xingtu-q2.png') },
        { src: require('./../page-one/img/xingtu-q3.png') },
        { src: require('./../page-one/img/xingtu-q4.png') },
        { src: require('./../page-one/img/xingtu-q5.png') },
        { src: require('./../page-one/img/xingtu-q6.png') },
        { src: require('./../page-one/img/xingtu-q7.png') },
        { src: require('./../page-one/img/photo.png') },
        { src: require('./../page-one/img/bg-bottom.png') },
        { src: require('./../page-one/img/bg-top.png') },
        { src: require('./../page-one/img/tdbig1.jpg') },
        { src: require('./../page-one/img/tdbig2.jpg') },
        { src: require('./../page-one/img/tdbig3.jpg') },
        { src: require('./../page-one/img/tdsmall1.jpg') },
        { src: require('./../page-one/img/tdsmall2.jpg') },
        { src: require('./../page-one/img/tdsmall3.jpg') },
        { src: require('./../page-one/img/mhaibao1.png') },
        { src: require('./../page-one/img/mhaibao2.png') },
        { src: require('./../page-one/img/mhaibao3.png') },
        { src: require('./../page-one/img/bighaibao1.png') },
        { src: require('./../page-one/img/bighaibao2.png') },
        { src: require('./../page-one/img/bighaibao3.png') },
        { src: require('./../page-one/img/mEwm1.png') },
        { src: require('./../page-one/img/mEwm2.png') },
        { src: require('./../page-one/img/mEwm3.png') },
        { src: require('./../page-one/img/bigEwm1.png') },
        { src: require('./../page-one/img/bigEwm2.png') },
        { src: require('./../page-one/img/bigEwm3.png') },
        { src: require('./../page-one/img/replayBtn.png') },
        { src: require('./../page-one/img/shareBtn.png') },
        { src: require('./../page-one/img/savetip.png') },
        { src: require('./../page-one/img/sharelayer.png') },
        { src: require('./../page-one/img/add.png') },
        { src: require('./../page-one/img/datiTitle.png') },
        { src: require('./../page-one/img/da0.png') },
        { src: require('./../page-one/img/da1.png') },
        { src: require('./../page-one/img/da2.png') },
        { src: require('./../page-one/img/da3.png') },
        { src: require('./../page-one/img/da4.png') },
        { src: require('./../page-one/img/da5.png') },
        { src: require('./../page-one/img/da6.png') },
        { src: require('./../page-one/img/da7.png') },
        { src: require('./../page-one/img/dtitle0.png') },
        { src: require('./../page-one/img/dtitle1.png') },
        { src: require('./../page-one/img/dtitle2.png') },
      ],
    };
  },
  methods: {
    generateId(index) {
      return "mImg" + index;
    },
    loadNextImg(imgID) {
      const _this = this;
      const len = this.preLoadImg.length;
      const curSrc = this.preLoadImg[imgID].src;
      let curImg = new Image();
      curImg.onload = function () {
        imgID++;
        _this.loadingNum = parseInt((imgID / len) * 100);
        if (imgID < len) {
          _this.loadNextImg(imgID);
        } else {
          //加载完成
        }
      };
      curImg.src = curSrc;
    },
    nextnext() {
      let imgID = 0;
      setTimeout(() => {
        this.loadNextImg(imgID);
      }, 1000);
    },
  },
  mounted() {},
  watch: {
    subnextload: function () {
      this.nextnext()
    },
  },
};
</script>

<style lang="less" scoped>
.bg(@url) {
  background-size: contain;
  background-image: url(@url);
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/pages/next/next.vue